import { Col, Form, FormInstance, Input, Row, Select } from 'antd'

type NurseFormProps = {
  form: FormInstance<any>
  disabledState: boolean
  updateState: boolean
  onFinish?: (values?: any) => void
}

function NurseForm({
  disabledState = false,
  form,
  onFinish,
  updateState,
}: NurseFormProps) {
  return (
    <Form
      layout='vertical'
      className='disabledViewForm'
      requiredMark={!disabledState}
      disabled={disabledState}
      form={form}
      onFinish={onFinish}
    >
      <Row gutter={16}>
        <Col span={5}>
          <Form.Item
            label='Title'
            name='title'
            rules={[
              { required: true, message: 'Please enter title' },
              { pattern: /^[A-Za-z.]*$/, message: 'Enter a Valid Title' },
            ]}
          >
            <Input placeholder='title' name='title' />
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            label='First Name'
            name='firstName'
            rules={[
              { required: true, message: 'Please enter first name' },
              {
                pattern: /^[a-zA-Z0-9.'\- ]+$/,
                message: 'Enter a valid first name',
              },
            ]}
          >
            <Input placeholder='first name' name='firstName' />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            label='Last Name'
            name='lastName'
            rules={[
              { required: true, message: 'Please enter last name' },
              {
                pattern: /^[a-zA-Z0-9.'\- ]+$/,
                message: 'Enter a valid last name',
              },
            ]}
          >
            <Input placeholder='last name' name='lastName' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={5}>
          <Form.Item
            name='isSupervisor'
            label='Is Supervisor'
            rules={[{ required: true, message: 'Is Supervisor' }]}
          >
            <Select
              options={[
                { value: 'Y', label: 'Yes' },
                { value: 'N', label: 'No' },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            name='nurseId'
            label='Nurse ID'
            rules={[
              { required: true, message: 'Please enter Nurse ID' },
              { max: 15, message: 'Nurse ID should not exceed 15 characters' },
            ]}
          >
            <Input placeholder='Please enter Nurse ID' />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            name='jobTitle'
            label='Job Title'
            rules={[{ required: true, message: 'Please enter Job Title' }]}
          >
            <Input placeholder='Please enter Job Title' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={14}>
          <Form.Item
            name='phonePrimary'
            label='Primary Phone Number'
            rules={[
              { required: true, message: 'Please enter primary phone number' },
              {
                pattern: /^\+(\d{1,4})\d{7,10}$/,
                message: 'Please enter valid phone number',
              },
            ]}
            extra='Use +61 format. Example: +61412345678'
          >
            <Input placeholder='Please enter primary phone number' />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            name='phoneSecondary'
            label='Secondary Phone Number'
            rules={[
              {
                pattern: /^\+(\d{1,4})\d{7,10}$/,
                message: 'Please enter valid phone number',
              },
            ]}
            extra='Use +61 format. Example: +61412345678'
          >
            <Input placeholder='Please enter secondary phone number' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name='emailId'
            label='Email Address'
            rules={[
              {
                required: updateState ? false : true,
                message: 'Please enter email Id',
                type: 'email',
              },
            ]}
          >
            <Input
              disabled={updateState ? true : undefined}
              placeholder='Please enter email Id'
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default NurseForm
